export default "__VITE_ASSET__CgFh9FV4__"